import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import api from '../helper/api';
import { getServerURL } from '../helper/envConfig';
import camera from '../assets/images/svg/camera.svg';
import { toast } from 'react-toastify';
import { errorResponse } from '../helper/error';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const Users = (props) => {

    const serverURL = getServerURL()
    const fileInputRef = useRef(null);
    const [editModalShow, setEditModalShow] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [states, setStates] = useState({})
    const [validated, setValidated] = useState(false);
    const [userData, setUserData] = useState([])
    const [deleteUserData, setDeleteUserData] = useState({})
    const [selectedImage, setSelectedImage] = useState()
    const [loading, setLoading] = useState(true)
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    const [subLoader, setSubLoader] = useState(false)

    useEffect(() => {
        getUserData();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    const getUserData = (event) => {
        api.getWithToken(`${serverURL}user/?page=${page}${searchText ? `&_s=${searchText}` : ""}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setUserData(res?.data?.data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const deleteUser = (event) => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}user/${deleteUserData?.id}`, deleteUserData)
            .then(async (res) => {
                setSubLoader(false)
                setDeleteModalShow(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getUserData()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
            })
            .catch((e) => {
                setSubLoader(false)
                errorResponse(e);
            });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setStates((prevValues) => ({
            ...prevValues,
            [name]: value.trimStart(),
        }));
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
            setStates({
                ...states,
                [e.target.name]: e.target.files[0],
            });
        }
    };

    const handleSubmit = (event) => {

        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);

            const formData = new FormData()
            formData.append("id", states?.id);
            formData.append("is_active", states?.is_active);
            formData.append("first_name", states?.first_name);
            formData.append("last_name", states?.last_name);
            formData.append("email", states?.email);
            formData.append("phone_number", states?.phone_number);
            formData.append("country", states?.country);
            if (states?.password) {
                formData.append("password", states?.password);
            }
            formData.append("profile_img", states?.profile_img);
            setLoading(true)
            setSubLoader(true)
            api.putWithToken(`${serverURL}user/`, formData)
                .then(async (res) => {
                    setLoading(false)
                    setEditModalShow(false)
                    setStates({})
                    form.reset();
                    setLoading(false);
                    setSubLoader(false)
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getUserData()
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setSubLoader(false)
                    setLoading(false)
                    errorResponse(e);
                });
        } else {
            setValidated(true);
            setSubLoader(false)
            setLoading(false)
            event.stopPropagation();
        }
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            {/* <Button variant={"outline-primary"} className='m-0' onClick={() => setModalShow(true)}>
                                {"Add"}
                            </Button> */}
                        </div>
                    </div>
                </Card.Header>

                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Image</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Country</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(userData?.length) ?
                                    userData?.map((item, index) =>
                                        <tr>
                                            <td>{(10 * (page - 1)) + (index + 1)}</td>
                                            <td>
                                                {item?.profile_img ?
                                                    <img className="rounded-circle" style={{ width: '40px' }} src={item?.profile_img} alt="activity-user" />
                                                    : "-"}
                                            </td>
                                            <td>
                                                <h6 className="m-0">{item?.first_name || "-"} </h6>
                                            </td>
                                            <td>
                                                <h6 className="m-0">{item?.last_name || "-"}</h6>
                                            </td>
                                            <td>
                                                <h6 className="m-0">{item?.email || "-"}</h6>
                                            </td>
                                            <td>
                                                <h6 className="m-0">{item?.phone_number || "-"}</h6>
                                            </td>
                                            <td>
                                                <h6 className="m-0">{item?.country || "-"}</h6>
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center gap-3'>
                                                    {/* <div className='cursor-pointer' onClick={() => setViewModalShow(true)}>
                                                <i className="feather icon-eye" title='View' />
                                            </div> */}
                                                    <div className='cursor-pointer' onClick={() => { setStates(item); setSelectedImage(""); setEditModalShow(true) }}>
                                                        <i className="feather icon-edit" title='Edit' />
                                                    </div>
                                                    <div className='cursor-pointer' onClick={() => { setDeleteUserData({ id: item?.id }); setDeleteModalShow(true) }}>
                                                        <i className="feather icon-trash-2" title='Delete' />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                    :
                                    <tr>
                                        <td colSpan={8} className='text-center'>
                                            No records found.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(userData?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}


            {/* edit Modal */}
            <Modal
                show={editModalShow}
                onHide={() => setEditModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h4">Edit {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>

                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className="mb-3 align-items-center" as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Image
                                    </Form.Label>
                                    <Col sm={9}>
                                        <div className="position-relative" id="profile_image">
                                            <div className="d-flex">
                                                <img
                                                    src={selectedImage || states?.profile_img}
                                                    onClick={handleImageClick}
                                                    className={`cursor-pointer profile-image`}
                                                />
                                            </div>
                                            <input
                                                type="file"
                                                // accept="image/*"
                                                accept=".jpg, .jpeg, .png, webm, .webp"
                                                name="profile_img"
                                                style={{ display: "none" }}
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                            />

                                            <img
                                                src={camera}
                                                onClick={handleImageClick}
                                                className="cursor-pointer position-absolute top-50 start-20 translate-middle"
                                                alt=""
                                            />
                                        </div>
                                        {/* <Form.Control type="text" required placeholder="Enter FirstName" value={states?.first_name || ""} name='first_name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter firstName.</Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        FirstName
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" required placeholder="Enter FirstName" value={states?.first_name || ""} name='first_name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter firstName.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalLastName">
                                    <Form.Label column sm={3}>
                                        LastName
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" required placeholder="Enter LastName" value={states?.last_name || ""} name='last_name' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter lastName.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalEmail">
                                    <Form.Label column sm={3}>
                                        Email
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="email" required placeholder="Email" value={states?.email || ""} name='email' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter email.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalPassword">
                                    <Form.Label column sm={3} type="password">
                                        Password
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter Password" value={states?.password || ""} name="password" onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter password.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>
                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalPhoneNumber">
                                    <Form.Label column sm={3}>
                                        Phone Number
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" required placeholder="Enter Phone Number" value={states?.phone_number || ""} name='phone_number' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter phone number.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-3" as={Row} controlId="formHorizontalPhoneNumber">
                                    <Form.Label column sm={3}>
                                        Country
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" required placeholder="Please enter country here" value={states?.country || ""} name='country' onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">Please enter country.</Form.Control.Feedback>
                                    </Col>
                                </Form.Group>

                                {/* <Form.Group className="mb-4" as={Row} controlId="formHorizontalCountry">
                                    <Form.Label column sm={3}>
                                        Country
                                    </Form.Label>
                                    <Col sm={9}>
                                        <InputGroup className="mb-3">
                                            <FormControl as="select" required aria-describedby="custom-addons1"
                                                className="custom-select" value={states?.country || ""} name='country' onChange={handleChange}>
                                                <option value={""}>Select Country</option>
                                                {Boolean(Array.isArray(makeData())) && makeData()?.map((item) =>
                                                    <option value={item?.code} key={item?.code}>{item?.name}</option>
                                                )}
                                            </FormControl>
                                            <Form.Control.Feedback type="invalid">Please select country.</Form.Control.Feedback>
                                        </InputGroup>
                                    </Col>
                                </Form.Group> */}

                                <div className='d-flex justify-content-end pt-2'>
                                    <Button type='submit'
                                        // onClick={(e) => handleSubmit(e)}
                                        // onClick={() => setModalShow(false)}
                                        className='m-0'>Save</Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>

            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    {Boolean(subLoader) && <Loader loading={subLoader} />}

                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deleteUser()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Users